var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSvg65(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 187.75 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-76);\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-143);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-107);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-133);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-165);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-80);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-15 {\n        fill: #785e66;\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-79);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-138);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-75);\n      }\n\n      .cls-19 {\n        fill: #334766;\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-61);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-116);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-100);\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath-71);\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-126);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-167);\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath-120);\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-33 {\n        clip-path: url(#clippath-103);\n      }\n\n      .cls-34 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-35 {\n        clip-path: url(#clippath-158);\n      }\n\n      .cls-36 {\n        clip-path: url(#clippath-140);\n      }\n\n      .cls-37 {\n        clip-path: url(#clippath-82);\n      }\n\n      .cls-38 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-39 {\n        clip-path: url(#clippath-66);\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-114);\n      }\n\n      .cls-41 {\n        clip-path: url(#clippath-149);\n      }\n\n      .cls-42 {\n        clip-path: url(#clippath-128);\n      }\n\n      .cls-43 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-142);\n      }\n\n      .cls-45 {\n        clip-path: url(#clippath-121);\n      }\n\n      .cls-46 {\n        clip-path: url(#clippath-102);\n      }\n\n      .cls-47 {\n        opacity: .5;\n      }\n\n      .cls-47, .cls-48 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-49 {\n        mix-blend-mode: color-dodge;\n      }\n\n      .cls-50 {\n        clip-path: url(#clippath-70);\n      }\n\n      .cls-51 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-52 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-53 {\n        clip-path: url(#clippath-164);\n      }\n\n      .cls-54 {\n        clip-path: url(#clippath-132);\n      }\n\n      .cls-55 {\n        clip-path: url(#clippath-59);\n      }\n\n      .cls-56 {\n        clip-path: url(#clippath-148);\n      }\n\n      .cls-57 {\n        clip-path: url(#clippath-160);\n      }\n\n      .cls-58 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-59 {\n        clip-path: url(#clippath-64);\n      }\n\n      .cls-60 {\n        clip-path: url(#clippath-101);\n      }\n\n      .cls-61 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-62 {\n        clip-path: url(#clippath-155);\n      }\n\n      .cls-63 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-64 {\n        clip-path: url(#clippath-139);\n      }\n\n      .cls-65 {\n        clip-path: url(#clippath-109);\n      }\n\n      .cls-66 {\n        clip-path: url(#clippath-151);\n      }\n\n      .cls-67 {\n        clip-path: url(#clippath-130);\n      }\n\n      .cls-68 {\n        clip-path: url(#clippath-60);\n      }\n\n      .cls-69 {\n        clip-path: url(#clippath-113);\n      }\n\n      .cls-70 {\n        clip-path: url(#clippath-171);\n      }\n\n      .cls-71 {\n        clip-path: url(#clippath-93);\n      }\n\n      .cls-72 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-73 {\n        clip-path: url(#clippath-57);\n      }\n\n      .cls-74 {\n        clip-path: url(#clippath-88);\n      }\n\n      .cls-75 {\n        fill: none;\n      }\n\n      .cls-76 {\n        clip-path: url(#clippath-170);\n      }\n\n      .cls-77 {\n        clip-path: url(#clippath-85);\n      }\n\n      .cls-78 {\n        clip-path: url(#clippath-159);\n      }\n\n      .cls-79 {\n        clip-path: url(#clippath-111);\n      }\n\n      .cls-80 {\n        clip-path: url(#clippath-168);\n      }\n\n      .cls-81 {\n        clip-path: url(#clippath-105);\n      }\n\n      .cls-82 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-83 {\n        clip-path: url(#clippath-92);\n      }\n\n      .cls-84 {\n        clip-path: url(#clippath-147);\n      }\n\n      .cls-85 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-86 {\n        clip-path: url(#clippath-98);\n      }\n\n      .cls-87 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-88 {\n        clip-path: url(#clippath-104);\n      }\n\n      .cls-89 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-90 {\n        clip-path: url(#clippath-118);\n      }\n\n      .cls-91 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-92 {\n        clip-path: url(#clippath-56);\n      }\n\n      .cls-93 {\n        clip-path: url(#clippath-108);\n      }\n\n      .cls-94 {\n        clip-path: url(#clippath-141);\n      }\n\n      .cls-95 {\n        clip-path: url(#clippath-90);\n      }\n\n      .cls-96 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-97 {\n        isolation: isolate;\n      }\n\n      .cls-98 {\n        clip-path: url(#clippath-110);\n      }\n\n      .cls-99 {\n        clip-path: url(#clippath-99);\n      }\n\n      .cls-100 {\n        clip-path: url(#clippath-89);\n      }\n\n      .cls-101 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-102 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-103 {\n        clip-path: url(#clippath-96);\n      }\n\n      .cls-104 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-105 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-106 {\n        clip-path: url(#clippath-95);\n      }\n\n      .cls-107 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-108 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-109 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-110 {\n        clip-path: url(#clippath-67);\n      }\n\n      .cls-111 {\n        clip-path: url(#clippath-154);\n      }\n\n      .cls-112 {\n        clip-path: url(#clippath-162);\n      }\n\n      .cls-113 {\n        clip-path: url(#clippath-74);\n      }\n\n      .cls-114 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-115 {\n        clip-path: url(#clippath-146);\n      }\n\n      .cls-116 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-117 {\n        clip-path: url(#clippath-91);\n      }\n\n      .cls-118 {\n        fill: #96bbd5;\n      }\n\n      .cls-119 {\n        clip-path: url(#clippath-137);\n      }\n\n      .cls-120 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-121 {\n        clip-path: url(#clippath-135);\n      }\n\n      .cls-122 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-123 {\n        clip-path: url(#clippath-153);\n      }\n\n      .cls-124 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-125 {\n        clip-path: url(#clippath-97);\n      }\n\n      .cls-126 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-127 {\n        clip-path: url(#clippath-112);\n      }\n\n      .cls-128 {\n        clip-path: url(#clippath-77);\n      }\n\n      .cls-129 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-130 {\n        fill: #33519f;\n      }\n\n      .cls-131 {\n        clip-path: url(#clippath-127);\n      }\n\n      .cls-132 {\n        clip-path: url(#clippath-117);\n      }\n\n      .cls-133 {\n        clip-path: url(#clippath-78);\n      }\n\n      .cls-134 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-135 {\n        clip-path: url(#clippath-72);\n      }\n\n      .cls-136 {\n        clip-path: url(#clippath-84);\n      }\n\n      .cls-137 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-138 {\n        clip-path: url(#clippath-145);\n      }\n\n      .cls-139 {\n        clip-path: url(#clippath-166);\n      }\n\n      .cls-140 {\n        clip-path: url(#clippath-55);\n      }\n\n      .cls-141 {\n        clip-path: url(#clippath-123);\n      }\n\n      .cls-142 {\n        clip-path: url(#clippath-129);\n      }\n\n      .cls-143 {\n        clip-path: url(#clippath-150);\n      }\n\n      .cls-144 {\n        clip-path: url(#clippath-73);\n      }\n\n      .cls-145 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-146 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-147 {\n        clip-path: url(#clippath-122);\n      }\n\n      .cls-148 {\n        clip-path: url(#clippath-81);\n      }\n\n      .cls-149 {\n        clip-path: url(#clippath-106);\n      }\n\n      .cls-150 {\n        clip-path: url(#clippath-125);\n      }\n\n      .cls-151 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-152 {\n        clip-path: url(#clippath-119);\n      }\n\n      .cls-153 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-154 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-155 {\n        clip-path: url(#clippath-131);\n      }\n\n      .cls-156 {\n        clip-path: url(#clippath-156);\n      }\n\n      .cls-157 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-158 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-159 {\n        clip-path: url(#clippath-58);\n      }\n\n      .cls-160 {\n        clip-path: url(#clippath-124);\n      }\n\n      .cls-161 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-162 {\n        clip-path: url(#clippath-136);\n      }\n\n      .cls-163 {\n        clip-path: url(#clippath-86);\n      }\n\n      .cls-164 {\n        clip-path: url(#clippath-144);\n      }\n\n      .cls-165 {\n        clip-path: url(#clippath-63);\n      }\n\n      .cls-166 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-167 {\n        clip-path: url(#clippath-94);\n      }\n\n      .cls-168 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-169 {\n        clip-path: url(#clippath-87);\n      }\n\n      .cls-170 {\n        clip-path: url(#clippath-68);\n      }\n\n      .cls-171 {\n        clip-path: url(#clippath-83);\n      }\n\n      .cls-172 {\n        clip-path: url(#clippath-65);\n      }\n\n      .cls-173 {\n        clip-path: url(#clippath-134);\n      }\n\n      .cls-174 {\n        clip-path: url(#clippath-157);\n      }\n\n      .cls-175 {\n        clip-path: url(#clippath-169);\n      }\n\n      .cls-176 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-177 {\n        clip-path: url(#clippath-115);\n      }\n\n      .cls-178 {\n        clip-path: url(#clippath-163);\n      }\n\n      .cls-179 {\n        clip-path: url(#clippath-62);\n      }\n\n      .cls-180 {\n        clip-path: url(#clippath-69);\n      }\n\n      .cls-181 {\n        clip-path: url(#clippath-161);\n      }\n\n      .cls-182 {\n        clip-path: url(#clippath-152);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M29.34,29.33c-.81,4.62.11,9.14,2.3,12.89l13.34-15.66-13.91-2.46c-.81,1.61-1.39,3.36-1.72,5.22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 8.68,
    width: 44.02,
    height: 48.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 49.18,
    y: 17.43,
    width: 19.24,
    height: 39.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.5,
    y: 8.68,
    width: 33.84,
    height: 24.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 19.17,
    width: 15.12,
    height: 29.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 61.23,
    y: 17.43,
    width: 7.19,
    height: 24.86
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.04,
    y: 8.68,
    width: 14.19,
    height: 8.76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.49,
    y: 15.34,
    width: 13.74,
    height: 11.06
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.04,
    y: 8.68,
    width: 8.58,
    height: 7.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.28,
    y: 48.95,
    width: 14.9,
    height: 7.94
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 19.53,
    width: 3.93,
    height: 13.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 16.47,
    width: 10.11,
    height: 16.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 28.32,
    y: 26.39,
    width: 18.72,
    height: 27.26
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 26.39,
    y: 16.47,
    width: 31.22,
    height: 15.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 46.24,
    y: 22.3,
    width: 20.93,
    height: 23.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 39.52,
    y: 31.86,
    width: 18.08,
    height: 25.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 39.52,
    y: 32.11,
    width: 18.73,
    height: 14.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.5,
    y: 13.57,
    width: 16.55,
    height: 8.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 38.46,
    y: 8.68,
    width: 9.03,
    height: 13.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 27.74,
    y: 8.68,
    width: 19.3,
    height: 10.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 15.35,
    width: 10.91,
    height: 17.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 30.05,
    width: 9.88,
    height: 18.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 32.78,
    width: 4.07,
    height: 6.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 26.06,
    y: 35.33,
    width: 14.97,
    height: 17.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 22.3,
    width: 23.09,
    height: 13.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 45.82,
    y: 8.68,
    width: 22.6,
    height: 20.59
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 43.37,
    y: 29.59,
    width: 23.79,
    height: 27.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 49.18,
    y: 46.11,
    width: 15.72,
    height: 10.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.28,
    y: 48.33,
    width: 22.24,
    height: 8.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M31.48,23.32l20.37,3.59-4.75-13.3c-6.55.34-12.45,4.06-15.62,9.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 8.68,
    width: 44.02,
    height: 48.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 49.18,
    y: 17.43,
    width: 19.24,
    height: 39.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.5,
    y: 8.68,
    width: 33.84,
    height: 24.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 19.17,
    width: 15.12,
    height: 29.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 61.23,
    y: 17.43,
    width: 7.19,
    height: 24.86
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.04,
    y: 8.68,
    width: 14.19,
    height: 8.76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.49,
    y: 15.34,
    width: 13.74,
    height: 11.06
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.04,
    y: 8.68,
    width: 8.58,
    height: 7.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.28,
    y: 48.95,
    width: 14.9,
    height: 7.94
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 19.53,
    width: 3.93,
    height: 13.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 16.47,
    width: 10.11,
    height: 16.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 28.32,
    y: 26.39,
    width: 18.72,
    height: 27.26
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 26.39,
    y: 16.47,
    width: 31.22,
    height: 15.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 46.24,
    y: 22.3,
    width: 20.93,
    height: 23.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 39.52,
    y: 31.86,
    width: 18.08,
    height: 25.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 39.52,
    y: 32.11,
    width: 18.73,
    height: 14.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.5,
    y: 13.57,
    width: 16.55,
    height: 8.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 38.46,
    y: 8.68,
    width: 9.03,
    height: 13.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 27.74,
    y: 8.68,
    width: 19.3,
    height: 10.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 15.35,
    width: 10.91,
    height: 17.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 30.05,
    width: 9.88,
    height: 18.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 32.78,
    width: 4.07,
    height: 6.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 26.06,
    y: 35.33,
    width: 14.97,
    height: 17.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 22.3,
    width: 23.09,
    height: 13.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 45.82,
    y: 8.68,
    width: 22.6,
    height: 20.59
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 43.37,
    y: 29.59,
    width: 23.79,
    height: 27.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 49.18,
    y: 46.11,
    width: 15.72,
    height: 10.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.28,
    y: 48.33,
    width: 22.24,
    height: 8.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M51.21,38.71l13.91,2.46c.8-1.61,1.39-3.36,1.72-5.22.81-4.61-.11-9.13-2.29-12.88l-13.34,15.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 8.68,
    width: 44.02,
    height: 48.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 49.18,
    y: 17.43,
    width: 19.24,
    height: 39.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.5,
    y: 8.68,
    width: 33.84,
    height: 24.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 19.17,
    width: 15.12,
    height: 29.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 61.23,
    y: 17.43,
    width: 7.19,
    height: 24.86
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.04,
    y: 8.68,
    width: 14.19,
    height: 8.76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.49,
    y: 15.34,
    width: 13.74,
    height: 11.06
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.04,
    y: 8.68,
    width: 8.58,
    height: 7.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.28,
    y: 48.95,
    width: 14.9,
    height: 7.94
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 19.53,
    width: 3.93,
    height: 13.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 16.47,
    width: 10.11,
    height: 16.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-70"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 28.32,
    y: 26.39,
    width: 18.72,
    height: 27.26
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-71"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 26.39,
    y: 16.47,
    width: 31.22,
    height: 15.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-72"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 46.24,
    y: 22.3,
    width: 20.93,
    height: 23.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-73"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 39.52,
    y: 31.86,
    width: 18.08,
    height: 25.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-74"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 39.52,
    y: 32.11,
    width: 18.73,
    height: 14.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-75"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.5,
    y: 13.57,
    width: 16.55,
    height: 8.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-76"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 38.46,
    y: 8.68,
    width: 9.03,
    height: 13.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-77"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 27.74,
    y: 8.68,
    width: 19.3,
    height: 10.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-78"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 15.35,
    width: 10.91,
    height: 17.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-79"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 30.05,
    width: 9.88,
    height: 18.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-80"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 32.78,
    width: 4.07,
    height: 6.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-81"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 26.06,
    y: 35.33,
    width: 14.97,
    height: 17.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-82"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 22.3,
    width: 23.09,
    height: 13.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-83"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 45.82,
    y: 8.68,
    width: 22.6,
    height: 20.59
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-84"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 43.37,
    y: 29.59,
    width: 23.79,
    height: 27.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-85"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 49.18,
    y: 46.11,
    width: 15.72,
    height: 10.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-86"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.28,
    y: 48.33,
    width: 22.24,
    height: 8.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M47.99,13.59l6.95,19.45,9.15-10.73c-2.77-4.29-7.25-7.46-12.68-8.42-1.12-.2-2.23-.29-3.33-.29-.03,0-.06,0-.08,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-88"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 8.68,
    width: 44.02,
    height: 48.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-89"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 49.18,
    y: 17.43,
    width: 19.24,
    height: 39.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-90"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.5,
    y: 8.68,
    width: 33.84,
    height: 24.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-91"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 19.17,
    width: 15.12,
    height: 29.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-92"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 61.23,
    y: 17.43,
    width: 7.19,
    height: 24.86
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-93"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.04,
    y: 8.68,
    width: 14.19,
    height: 8.76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-94"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.49,
    y: 15.34,
    width: 13.74,
    height: 11.06
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-95"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.04,
    y: 8.68,
    width: 8.58,
    height: 7.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-96"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.28,
    y: 48.95,
    width: 14.9,
    height: 7.94
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-97"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 19.53,
    width: 3.93,
    height: 13.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-98"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 16.47,
    width: 10.11,
    height: 16.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-99"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 28.32,
    y: 26.39,
    width: 18.72,
    height: 27.26
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-100"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 26.39,
    y: 16.47,
    width: 31.22,
    height: 15.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-101"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 46.24,
    y: 22.3,
    width: 20.93,
    height: 23.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-102"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 39.52,
    y: 31.86,
    width: 18.08,
    height: 25.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-103"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 39.52,
    y: 32.11,
    width: 18.73,
    height: 14.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-104"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.5,
    y: 13.57,
    width: 16.55,
    height: 8.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-105"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 38.46,
    y: 8.68,
    width: 9.03,
    height: 13.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-106"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 27.74,
    y: 8.68,
    width: 19.3,
    height: 10.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-107"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 15.35,
    width: 10.91,
    height: 17.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-108"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 30.05,
    width: 9.88,
    height: 18.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-109"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 32.78,
    width: 4.07,
    height: 6.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-110"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 26.06,
    y: 35.33,
    width: 14.97,
    height: 17.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-111"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 22.3,
    width: 23.09,
    height: 13.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-112"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 45.82,
    y: 8.68,
    width: 22.6,
    height: 20.59
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-113"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 43.37,
    y: 29.59,
    width: 23.79,
    height: 27.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-114"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 49.18,
    y: 46.11,
    width: 15.72,
    height: 10.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-115"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.28,
    y: 48.33,
    width: 22.24,
    height: 8.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M32.11,42.98c2.77,4.29,7.25,7.45,12.68,8.41,1.22.22,2.44.31,3.63.29l-7.16-19.45-9.15,10.75Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-117"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 8.68,
    width: 44.02,
    height: 48.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-118"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 49.18,
    y: 17.43,
    width: 19.24,
    height: 39.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-119"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.5,
    y: 8.68,
    width: 33.84,
    height: 24.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-120"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 19.17,
    width: 15.12,
    height: 29.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-121"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 61.23,
    y: 17.43,
    width: 7.19,
    height: 24.86
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-122"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.04,
    y: 8.68,
    width: 14.19,
    height: 8.76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-123"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.49,
    y: 15.34,
    width: 13.74,
    height: 11.06
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-124"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.04,
    y: 8.68,
    width: 8.58,
    height: 7.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-125"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.28,
    y: 48.95,
    width: 14.9,
    height: 7.94
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-126"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 19.53,
    width: 3.93,
    height: 13.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-127"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 16.47,
    width: 10.11,
    height: 16.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-128"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 28.32,
    y: 26.39,
    width: 18.72,
    height: 27.26
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-129"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 26.39,
    y: 16.47,
    width: 31.22,
    height: 15.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-130"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 46.24,
    y: 22.3,
    width: 20.93,
    height: 23.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-131"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 39.52,
    y: 31.86,
    width: 18.08,
    height: 25.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-132"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 39.52,
    y: 32.11,
    width: 18.73,
    height: 14.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-133"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.5,
    y: 13.57,
    width: 16.55,
    height: 8.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-134"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 38.46,
    y: 8.68,
    width: 9.03,
    height: 13.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-135"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 27.74,
    y: 8.68,
    width: 19.3,
    height: 10.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-136"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 15.35,
    width: 10.91,
    height: 17.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-137"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 30.05,
    width: 9.88,
    height: 18.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-138"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 32.78,
    width: 4.07,
    height: 6.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-139"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 26.06,
    y: 35.33,
    width: 14.97,
    height: 17.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-140"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 22.3,
    width: 23.09,
    height: 13.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-141"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 45.82,
    y: 8.68,
    width: 22.6,
    height: 20.59
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-142"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 43.37,
    y: 29.59,
    width: 23.79,
    height: 27.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-143"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 49.18,
    y: 46.11,
    width: 15.72,
    height: 10.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-144"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.28,
    y: 48.33,
    width: 22.24,
    height: 8.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M49.31,51.64c6.46-.41,12.27-4.11,15.4-9.69l-20.28-3.58,4.89,13.27Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-146"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 8.68,
    width: 44.02,
    height: 48.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-147"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 49.18,
    y: 17.43,
    width: 19.24,
    height: 39.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-148"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.5,
    y: 8.68,
    width: 33.84,
    height: 24.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-149"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 19.17,
    width: 15.12,
    height: 29.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-150"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 61.23,
    y: 17.43,
    width: 7.19,
    height: 24.86
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-151"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.04,
    y: 8.68,
    width: 14.19,
    height: 8.76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-152"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.49,
    y: 15.34,
    width: 13.74,
    height: 11.06
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-153"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 47.04,
    y: 8.68,
    width: 8.58,
    height: 7.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-154"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.28,
    y: 48.95,
    width: 14.9,
    height: 7.94
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-155"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 19.53,
    width: 3.93,
    height: 13.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-156"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 16.47,
    width: 10.11,
    height: 16.31
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-157"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 28.32,
    y: 26.39,
    width: 18.72,
    height: 27.26
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-158"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 26.39,
    y: 16.47,
    width: 31.22,
    height: 15.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-159"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 46.57,
    y: 22.3,
    width: 20.93,
    height: 23.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-160"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 39.52,
    y: 31.86,
    width: 18.08,
    height: 25.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-161"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.5,
    y: 13.57,
    width: 16.55,
    height: 8.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-162"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 38.46,
    y: 8.68,
    width: 9.03,
    height: 13.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-163"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 27.74,
    y: 8.68,
    width: 19.3,
    height: 10.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-164"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 15.35,
    width: 10.91,
    height: 17.43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-165"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 30.05,
    width: 9.88,
    height: 18.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-166"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 32.78,
    width: 4.07,
    height: 6.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-167"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 26.06,
    y: 35.33,
    width: 14.97,
    height: 17.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-168"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 24.4,
    y: 22.3,
    width: 23.09,
    height: 13.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-169"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 45.82,
    y: 8.68,
    width: 22.6,
    height: 20.59
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-170"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 49.18,
    y: 46.11,
    width: 15.72,
    height: 10.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-171"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 34.28,
    y: 48.33,
    width: 22.24,
    height: 8.56
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "47.04 8.68 39.52 16.85 39.52 16.35 43.28 11.68 47.04 8.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M68.42,29.26l-1.57,13.03-1.95,3.82-8.38,5.75-7.34,5.04-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08-.27-.31-1.24-1.25-1.6-1.59-.09-.08-.14-.13-.14-.13l-1.84-.98h-.02s0-.01,0-.01l-6.75-3.58-5.81-9.51-2.41-3.94-1.66-2.72s.26-1.13.64-2.73c.38-1.61.88-3.7,1.35-5.59.06-.24.12-.48.18-.71.55-2.19,1.02-3.97,1.18-4.19.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7.63-.36,1.3-.73,1.97-1.11,1.03-.59,2.1-1.19,3.15-1.79,4.37-2.48,8.45-4.81,8.58-4.89h0s8.58,5.29,8.58,5.29l5.61,3.46,2.84,4.94,4.26,6.76.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M25.74,30.03c-.04.05-.08.1-.13.14-.03,0-.06,0-.1,0l.22-.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 66.85 42.29 64.9 46.11 49.18 56.89 57.86 42.07 57.49 30.03 61.23 17.43 64.08 22.38 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.34 29.14 62.43 33.16 47.49 22.3 34.5 22.3 47.04 8.68 47.04 8.68 61.23 17.43 64.08 22.38 68.34 29.14"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M39.52,32.11l-.45,8.31-4.79,8.53-9.88-16.17s3.07-13.25,3.37-13.25c.03,0,.29-.13.72-.36l6.02,3.13,5.02,9.81Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 66.85 42.29 62.43 33.16 61.23 17.43 64.08 22.38 68.34 29.14 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "61.23 17.43 51.05 17.43 47.04 8.68 61.23 17.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-130",
    points: "61.01 17.51 53.12 26.39 47.49 22.3 51.05 17.43 54.14 15.34 61.23 17.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "55.62 13.97 52.99 16.12 47.04 8.68 55.62 13.97"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M49.18,56.89l-2.14-.45s-2.21-.9-2.36-1.12c-.15-.23-1.8-1.8-1.8-1.8l-8.61-4.57,12.76,1.5,2.14,6.44Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M28.32,26.39l-3.93,6.39s2.92-12.6,3.34-13.23l.03-.02.56,6.86Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.5,22.3l-10.11,10.48s2.92-12.6,3.34-13.23c.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7l1.17,5.83Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.04,50.45l-4.02,3.2c-.09-.08-.14-.13-.14-.13l-8.61-4.57-5.96-22.56,11.2,5.71,7.52,18.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M57.6,29.65l-18.08,2.46-10.72-3.9-2.42-3.76c.62-2.5,1.18-4.65,1.35-4.9.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7l17.71.97,6.55,12.21Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "67.17 29.26 65.6 42.29 63.65 46.11 56.61 42.07 48.97 46.2 46.24 22.3 63.57 38.68 67.09 29.14 67.17 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M57.6,31.86l-7.38,14.34-1.04,10.69-2.14-.45s-2.21-.9-2.36-1.12c-.12-.19-1.26-1.28-1.66-1.67-.09-.08-.14-.13-.14-.13l-1.84-.98-1.53-20.44,18.08-.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "58.26 42.29 39.52 32.11 50.22 46.2 58.26 42.29"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-130",
    points: "51.05 17.43 34.5 22.3 38.46 13.57 50.83 17.4"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.49,22.3l-9.03-8.74c4.41-2.5,8.51-4.85,8.58-4.89h0s.45,13.63.45,13.63Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.04,8.68l-6.02,4.38-6.52,4.88-6.77,1.62s.02-.02.03-.02c.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7,1.6-.9,3.39-1.91,5.13-2.9,4.37-2.48,8.45-4.81,8.58-4.89"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M35.31,15.35l-.8,2.58-6.77,5.78-3.34,9.07s1.06-4.56,1.99-8.33c.62-2.5,1.18-4.65,1.35-4.9.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7.63-.36,1.3-.73,1.97-1.11"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.28,48.95l-9.88-16.17s.26-1.13.64-2.73l3.64,7.11,5.6,11.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "28.47 39.44 24.4 32.78 27.74 35.33 28.47 39.44"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "41.03 52.53 34.28 48.95 28.47 39.44 26.06 35.5 27.74 35.33 35.31 47.12 41.03 52.53"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.49,22.3l-7.97,9.81-8.63,4-3.15-.79-3.34-2.54s.26-1.13.64-2.73c.38-1.61.88-3.7,1.35-5.59.06-.24.12-.48.18-.71l20.93-1.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 63.68 25.02 59.18 18.85 55.62 14.85 49.18 12.4 45.82 10.5 47.04 8.68 47.04 8.68 55.62 13.97 61.23 17.43 64.08 22.38 68.34 29.14 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M67.17,29.59l-1.57,13.03-1.95,3.82-15.72,10.78-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08l.39-.45,4.43-.51,5.3-3.99,8.13-5.01,1.94-2.61-.42-1.96,1.38-2.11,2.63-9.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "64.9 46.11 49.18 56.89 53.44 52.04 64.9 46.11"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M56.52,51.85l-7.34,5.04-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08-.27-.31-1.24-1.25-1.6-1.59-.09-.08-.14-.13-.14-.13l-1.84-.98h-.02s0-.01,0-.01l-6.75-3.58,1.37-.62,7.32,3.17,3.43,3.44,10.11-3.09Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "47.04 8.68 39.52 16.85 39.52 16.35 43.28 11.68 47.04 8.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M68.42,29.26l-1.57,13.03-1.95,3.82-8.38,5.75-7.34,5.04-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08-.27-.31-1.24-1.25-1.6-1.59-.09-.08-.14-.13-.14-.13l-1.84-.98h-.02s0-.01,0-.01l-6.75-3.58-5.81-9.51-2.41-3.94-1.66-2.72s.26-1.13.64-2.73c.38-1.61.88-3.7,1.35-5.59.06-.24.12-.48.18-.71.55-2.19,1.02-3.97,1.18-4.19.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7.63-.36,1.3-.73,1.97-1.11,1.03-.59,2.1-1.19,3.15-1.79,4.37-2.48,8.45-4.81,8.58-4.89h0s8.58,5.29,8.58,5.29l5.61,3.46,2.84,4.94,4.26,6.76.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M25.74,30.03c-.04.05-.08.1-.13.14-.03,0-.06,0-.1,0l.22-.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 66.85 42.29 64.9 46.11 49.18 56.89 57.86 42.07 57.49 30.03 61.23 17.43 64.08 22.38 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-137"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.34 29.14 62.43 33.16 47.49 22.3 34.5 22.3 47.04 8.68 47.04 8.68 61.23 17.43 64.08 22.38 68.34 29.14"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M39.52,32.11l-.45,8.31-4.79,8.53-9.88-16.17s3.07-13.25,3.37-13.25c.03,0,.29-.13.72-.36l6.02,3.13,5.02,9.81Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 66.85 42.29 62.43 33.16 61.23 17.43 64.08 22.38 68.34 29.14 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "61.23 17.43 51.05 17.43 47.04 8.68 61.23 17.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-130",
    points: "61.01 17.51 53.12 26.39 47.49 22.3 51.05 17.43 54.14 15.34 61.23 17.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "55.62 13.97 52.99 16.12 47.04 8.68 55.62 13.97"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M49.18,56.89l-2.14-.45s-2.21-.9-2.36-1.12c-.15-.23-1.8-1.8-1.8-1.8l-8.61-4.57,12.76,1.5,2.14,6.44Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M28.32,26.39l-3.93,6.39s2.92-12.6,3.34-13.23l.03-.02.56,6.86Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.5,22.3l-10.11,10.48s2.92-12.6,3.34-13.23c.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7l1.17,5.83Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.04,50.45l-4.02,3.2c-.09-.08-.14-.13-.14-.13l-8.61-4.57-5.96-22.56,11.2,5.71,7.52,18.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M57.6,29.65l-18.08,2.46-10.72-3.9-2.42-3.76c.62-2.5,1.18-4.65,1.35-4.9.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7l17.71.97,6.55,12.21Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "67.17 29.26 65.6 42.29 63.65 46.11 56.61 42.07 48.97 46.2 46.24 22.3 63.57 38.68 67.09 29.14 67.17 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M57.6,31.86l-7.38,14.34-1.04,10.69-2.14-.45s-2.21-.9-2.36-1.12c-.12-.19-1.26-1.28-1.66-1.67-.09-.08-.14-.13-.14-.13l-1.84-.98-1.53-20.44,18.08-.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "58.26 42.29 39.52 32.11 50.22 46.2 58.26 42.29"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-130",
    points: "51.05 17.43 34.5 22.3 38.46 13.57 50.83 17.4"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.49,22.3l-9.03-8.74c4.41-2.5,8.51-4.85,8.58-4.89h0s.45,13.63.45,13.63Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.04,8.68l-6.02,4.38-6.52,4.88-6.77,1.62s.02-.02.03-.02c.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7,1.6-.9,3.39-1.91,5.13-2.9,4.37-2.48,8.45-4.81,8.58-4.89"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M35.31,15.35l-.8,2.58-6.77,5.78-3.34,9.07s1.06-4.56,1.99-8.33c.62-2.5,1.18-4.65,1.35-4.9.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7.63-.36,1.3-.73,1.97-1.11"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.28,48.95l-9.88-16.17s.26-1.13.64-2.73l3.64,7.11,5.6,11.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "28.47 39.44 24.4 32.78 27.74 35.33 28.47 39.44"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "41.03 52.53 34.28 48.95 28.47 39.44 26.06 35.5 27.74 35.33 35.31 47.12 41.03 52.53"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.49,22.3l-7.97,9.81-8.63,4-3.15-.79-3.34-2.54s.26-1.13.64-2.73c.38-1.61.88-3.7,1.35-5.59.06-.24.12-.48.18-.71l20.93-1.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 63.68 25.02 59.18 18.85 55.62 14.85 49.18 12.4 45.82 10.5 47.04 8.68 47.04 8.68 55.62 13.97 61.23 17.43 64.08 22.38 68.34 29.14 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M67.17,29.59l-1.57,13.03-1.95,3.82-15.72,10.78-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08l.39-.45,4.43-.51,5.3-3.99,8.13-5.01,1.94-2.61-.42-1.96,1.38-2.11,2.63-9.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "64.9 46.11 49.18 56.89 53.44 52.04 64.9 46.11"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M56.52,51.85l-7.34,5.04-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08-.27-.31-1.24-1.25-1.6-1.59-.09-.08-.14-.13-.14-.13l-1.84-.98h-.02s0-.01,0-.01l-6.75-3.58,1.37-.62,7.32,3.17,3.43,3.44,10.11-3.09Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "47.04 8.68 39.52 16.85 39.52 16.35 43.28 11.68 47.04 8.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M68.42,29.26l-1.57,13.03-1.95,3.82-8.38,5.75-7.34,5.04-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08-.27-.31-1.24-1.25-1.6-1.59-.09-.08-.14-.13-.14-.13l-1.84-.98h-.02s0-.01,0-.01l-6.75-3.58-5.81-9.51-2.41-3.94-1.66-2.72s.26-1.13.64-2.73c.38-1.61.88-3.7,1.35-5.59.06-.24.12-.48.18-.71.55-2.19,1.02-3.97,1.18-4.19.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7.63-.36,1.3-.73,1.97-1.11,1.03-.59,2.1-1.19,3.15-1.79,4.37-2.48,8.45-4.81,8.58-4.89h0s8.58,5.29,8.58,5.29l5.61,3.46,2.84,4.94,4.26,6.76.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M25.74,30.03c-.04.05-.08.1-.13.14-.03,0-.06,0-.1,0l.22-.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 66.85 42.29 64.9 46.11 49.18 56.89 57.86 42.07 57.49 30.03 61.23 17.43 64.08 22.38 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.34 29.14 62.43 33.16 47.49 22.3 34.5 22.3 47.04 8.68 47.04 8.68 61.23 17.43 64.08 22.38 68.34 29.14"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M39.52,32.11l-.45,8.31-4.79,8.53-9.88-16.17s3.07-13.25,3.37-13.25c.03,0,.29-.13.72-.36l6.02,3.13,5.02,9.81Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 66.85 42.29 62.43 33.16 61.23 17.43 64.08 22.38 68.34 29.14 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "61.23 17.43 51.05 17.43 47.04 8.68 61.23 17.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-130",
    points: "61.01 17.51 53.12 26.39 47.49 22.3 51.05 17.43 54.14 15.34 61.23 17.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "55.62 13.97 52.99 16.12 47.04 8.68 55.62 13.97"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M49.18,56.89l-2.14-.45s-2.21-.9-2.36-1.12c-.15-.23-1.8-1.8-1.8-1.8l-8.61-4.57,12.76,1.5,2.14,6.44Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M28.32,26.39l-3.93,6.39s2.92-12.6,3.34-13.23l.03-.02.56,6.86Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.5,22.3l-10.11,10.48s2.92-12.6,3.34-13.23c.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7l1.17,5.83Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.04,50.45l-4.02,3.2c-.09-.08-.14-.13-.14-.13l-8.61-4.57-5.96-22.56,11.2,5.71,7.52,18.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M57.6,29.65l-18.08,2.46-10.72-3.9-2.42-3.76c.62-2.5,1.18-4.65,1.35-4.9.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7l17.71.97,6.55,12.21Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "67.17 29.26 65.6 42.29 63.65 46.11 56.61 42.07 48.97 46.2 46.24 22.3 63.57 38.68 67.09 29.14 67.17 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M57.6,31.86l-7.38,14.34-1.04,10.69-2.14-.45s-2.21-.9-2.36-1.12c-.12-.19-1.26-1.28-1.66-1.67-.09-.08-.14-.13-.14-.13l-1.84-.98-1.53-20.44,18.08-.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "58.26 42.29 39.52 32.11 50.22 46.2 58.26 42.29"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-130",
    points: "51.05 17.43 34.5 22.3 38.46 13.57 50.83 17.4"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.49,22.3l-9.03-8.74c4.41-2.5,8.51-4.85,8.58-4.89h0s.45,13.63.45,13.63Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.04,8.68l-6.02,4.38-6.52,4.88-6.77,1.62s.02-.02.03-.02c.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7,1.6-.9,3.39-1.91,5.13-2.9,4.37-2.48,8.45-4.81,8.58-4.89"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M35.31,15.35l-.8,2.58-6.77,5.78-3.34,9.07s1.06-4.56,1.99-8.33c.62-2.5,1.18-4.65,1.35-4.9.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7.63-.36,1.3-.73,1.97-1.11"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.28,48.95l-9.88-16.17s.26-1.13.64-2.73l3.64,7.11,5.6,11.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "28.47 39.44 24.4 32.78 27.74 35.33 28.47 39.44"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "41.03 52.53 34.28 48.95 28.47 39.44 26.06 35.5 27.74 35.33 35.31 47.12 41.03 52.53"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.49,22.3l-7.97,9.81-8.63,4-3.15-.79-3.34-2.54s.26-1.13.64-2.73c.38-1.61.88-3.7,1.35-5.59.06-.24.12-.48.18-.71l20.93-1.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 63.68 25.02 59.18 18.85 55.62 14.85 49.18 12.4 45.82 10.5 47.04 8.68 47.04 8.68 55.62 13.97 61.23 17.43 64.08 22.38 68.34 29.14 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M67.17,29.59l-1.57,13.03-1.95,3.82-15.72,10.78-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08l.39-.45,4.43-.51,5.3-3.99,8.13-5.01,1.94-2.61-.42-1.96,1.38-2.11,2.63-9.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "64.9 46.11 49.18 56.89 53.44 52.04 64.9 46.11"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M56.52,51.85l-7.34,5.04-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08-.27-.31-1.24-1.25-1.6-1.59-.09-.08-.14-.13-.14-.13l-1.84-.98h-.02s0-.01,0-.01l-6.75-3.58,1.37-.62,7.32,3.17,3.43,3.44,10.11-3.09Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "47.04 8.68 39.52 16.85 39.52 16.35 43.28 11.68 47.04 8.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M68.42,29.26l-1.57,13.03-1.95,3.82-8.38,5.75-7.34,5.04-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08-.27-.31-1.24-1.25-1.6-1.59-.09-.08-.14-.13-.14-.13l-1.84-.98h-.02s0-.01,0-.01l-6.75-3.58-5.81-9.51-2.41-3.94-1.66-2.72s.26-1.13.64-2.73c.38-1.61.88-3.7,1.35-5.59.06-.24.12-.48.18-.71.55-2.19,1.02-3.97,1.18-4.19.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7.63-.36,1.3-.73,1.97-1.11,1.03-.59,2.1-1.19,3.15-1.79,4.37-2.48,8.45-4.81,8.58-4.89h0s8.58,5.29,8.58,5.29l5.61,3.46,2.84,4.94,4.26,6.76.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M25.74,30.03c-.04.05-.08.1-.13.14-.03,0-.06,0-.1,0l.22-.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 66.85 42.29 64.9 46.11 49.18 56.89 57.86 42.07 57.49 30.03 61.23 17.43 64.08 22.38 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.34 29.14 62.43 33.16 47.49 22.3 34.5 22.3 47.04 8.68 47.04 8.68 61.23 17.43 64.08 22.38 68.34 29.14"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M39.52,32.11l-.45,8.31-4.79,8.53-9.88-16.17s3.07-13.25,3.37-13.25c.03,0,.29-.13.72-.36l6.02,3.13,5.02,9.81Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 66.85 42.29 62.43 33.16 61.23 17.43 64.08 22.38 68.34 29.14 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "61.23 17.43 51.05 17.43 47.04 8.68 61.23 17.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-130",
    points: "61.01 17.51 53.12 26.39 47.49 22.3 51.05 17.43 54.14 15.34 61.23 17.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "55.62 13.97 52.99 16.12 47.04 8.68 55.62 13.97"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M49.18,56.89l-2.14-.45s-2.21-.9-2.36-1.12c-.15-.23-1.8-1.8-1.8-1.8l-8.61-4.57,12.76,1.5,2.14,6.44Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M28.32,26.39l-3.93,6.39s2.92-12.6,3.34-13.23l.03-.02.56,6.86Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.5,22.3l-10.11,10.48s2.92-12.6,3.34-13.23c.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7l1.17,5.83Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.04,50.45l-4.02,3.2c-.09-.08-.14-.13-.14-.13l-8.61-4.57-5.96-22.56,11.2,5.71,7.52,18.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M57.6,29.65l-18.08,2.46-10.72-3.9-2.42-3.76c.62-2.5,1.18-4.65,1.35-4.9.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7l17.71.97,6.55,12.21Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "67.17 29.26 65.6 42.29 63.65 46.11 56.61 42.07 48.97 46.2 46.24 22.3 63.57 38.68 67.09 29.14 67.17 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M57.6,31.86l-7.38,14.34-1.04,10.69-2.14-.45s-2.21-.9-2.36-1.12c-.12-.19-1.26-1.28-1.66-1.67-.09-.08-.14-.13-.14-.13l-1.84-.98-1.53-20.44,18.08-.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "58.26 42.29 39.52 32.11 50.22 46.2 58.26 42.29"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-130",
    points: "51.05 17.43 34.5 22.3 38.46 13.57 50.83 17.4"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.49,22.3l-9.03-8.74c4.41-2.5,8.51-4.85,8.58-4.89h0s.45,13.63.45,13.63Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.04,8.68l-6.02,4.38-6.52,4.88-6.77,1.62s.02-.02.03-.02c.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7,1.6-.9,3.39-1.91,5.13-2.9,4.37-2.48,8.45-4.81,8.58-4.89"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M35.31,15.35l-.8,2.58-6.77,5.78-3.34,9.07s1.06-4.56,1.99-8.33c.62-2.5,1.18-4.65,1.35-4.9.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7.63-.36,1.3-.73,1.97-1.11"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.28,48.95l-9.88-16.17s.26-1.13.64-2.73l3.64,7.11,5.6,11.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "28.47 39.44 24.4 32.78 27.74 35.33 28.47 39.44"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "41.03 52.53 34.28 48.95 28.47 39.44 26.06 35.5 27.74 35.33 35.31 47.12 41.03 52.53"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.49,22.3l-7.97,9.81-8.63,4-3.15-.79-3.34-2.54s.26-1.13.64-2.73c.38-1.61.88-3.7,1.35-5.59.06-.24.12-.48.18-.71l20.93-1.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-127"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 63.68 25.02 59.18 18.85 55.62 14.85 49.18 12.4 45.82 10.5 47.04 8.68 47.04 8.68 55.62 13.97 61.23 17.43 64.08 22.38 68.34 29.14 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M67.17,29.59l-1.57,13.03-1.95,3.82-15.72,10.78-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08l.39-.45,4.43-.51,5.3-3.99,8.13-5.01,1.94-2.61-.42-1.96,1.38-2.11,2.63-9.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "64.9 46.11 49.18 56.89 53.44 52.04 64.9 46.11"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M56.52,51.85l-7.34,5.04-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08-.27-.31-1.24-1.25-1.6-1.59-.09-.08-.14-.13-.14-.13l-1.84-.98h-.02s0-.01,0-.01l-6.75-3.58,1.37-.62,7.32,3.17,3.43,3.44,10.11-3.09Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "47.04 8.68 39.52 16.85 39.52 16.35 43.28 11.68 47.04 8.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M68.42,29.26l-1.57,13.03-1.95,3.82-8.38,5.75-7.34,5.04-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08-.27-.31-1.24-1.25-1.6-1.59-.09-.08-.14-.13-.14-.13l-1.84-.98h-.02s0-.01,0-.01l-6.75-3.58-5.81-9.51-2.41-3.94-1.66-2.72s.26-1.13.64-2.73c.38-1.61.88-3.7,1.35-5.59.06-.24.12-.48.18-.71.55-2.19,1.02-3.97,1.18-4.19.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7.63-.36,1.3-.73,1.97-1.11,1.03-.59,2.1-1.19,3.15-1.79,4.37-2.48,8.45-4.81,8.58-4.89h0s8.58,5.29,8.58,5.29l5.61,3.46,2.84,4.94,4.26,6.76.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M25.74,30.03c-.04.05-.08.1-.13.14-.03,0-.06,0-.1,0l.22-.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 66.85 42.29 64.9 46.11 49.18 56.89 57.86 42.07 57.49 30.03 61.23 17.43 64.08 22.38 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.34 29.14 62.43 33.16 47.49 22.3 34.5 22.3 47.04 8.68 47.04 8.68 61.23 17.43 64.08 22.38 68.34 29.14"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M39.52,32.11l-.45,8.31-4.79,8.53-9.88-16.17s3.07-13.25,3.37-13.25c.03,0,.29-.13.72-.36l6.02,3.13,5.02,9.81Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 66.85 42.29 62.43 33.16 61.23 17.43 64.08 22.38 68.34 29.14 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "61.23 17.43 51.05 17.43 47.04 8.68 61.23 17.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-130",
    points: "61.01 17.51 53.12 26.39 47.49 22.3 51.05 17.43 54.14 15.34 61.23 17.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "55.62 13.97 52.99 16.12 47.04 8.68 55.62 13.97"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M49.18,56.89l-2.14-.45s-2.21-.9-2.36-1.12c-.15-.23-1.8-1.8-1.8-1.8l-8.61-4.57,12.76,1.5,2.14,6.44Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M28.32,26.39l-3.93,6.39s2.92-12.6,3.34-13.23l.03-.02.56,6.86Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.5,22.3l-10.11,10.48s2.92-12.6,3.34-13.23c.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7l1.17,5.83Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.04,50.45l-4.02,3.2c-.09-.08-.14-.13-.14-.13l-8.61-4.57-5.96-22.56,11.2,5.71,7.52,18.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M57.6,29.65l-18.08,2.46-10.72-3.9-2.42-3.76c.62-2.5,1.18-4.65,1.35-4.9.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7l17.71.97,6.55,12.21Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "67.17 29.26 65.6 42.29 63.65 46.11 56.61 42.07 48.97 46.2 46.24 22.3 63.57 38.68 67.09 29.14 67.17 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M57.6,31.86l-7.38,14.34-1.04,10.69-2.14-.45s-2.21-.9-2.36-1.12c-.12-.19-1.26-1.28-1.66-1.67-.09-.08-.14-.13-.14-.13l-1.84-.98-1.53-20.44,18.08-.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "58.26 42.29 39.52 32.11 50.22 46.2 58.26 42.29"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-130",
    points: "51.05 17.43 34.5 22.3 38.46 13.57 50.83 17.4"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.49,22.3l-9.03-8.74c4.41-2.5,8.51-4.85,8.58-4.89h0s.45,13.63.45,13.63Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.04,8.68l-6.02,4.38-6.52,4.88-6.77,1.62s.02-.02.03-.02c.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7,1.6-.9,3.39-1.91,5.13-2.9,4.37-2.48,8.45-4.81,8.58-4.89"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M35.31,15.35l-.8,2.58-6.77,5.78-3.34,9.07s1.06-4.56,1.99-8.33c.62-2.5,1.18-4.65,1.35-4.9.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7.63-.36,1.3-.73,1.97-1.11"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-119"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.28,48.95l-9.88-16.17s.26-1.13.64-2.73l3.64,7.11,5.6,11.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "28.47 39.44 24.4 32.78 27.74 35.33 28.47 39.44"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "41.03 52.53 34.28 48.95 28.47 39.44 26.06 35.5 27.74 35.33 35.31 47.12 41.03 52.53"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.49,22.3l-7.97,9.81-8.63,4-3.15-.79-3.34-2.54s.26-1.13.64-2.73c.38-1.61.88-3.7,1.35-5.59.06-.24.12-.48.18-.71l20.93-1.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 63.68 25.02 59.18 18.85 55.62 14.85 49.18 12.4 45.82 10.5 47.04 8.68 47.04 8.68 55.62 13.97 61.23 17.43 64.08 22.38 68.34 29.14 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M67.17,29.59l-1.57,13.03-1.95,3.82-15.72,10.78-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08l.39-.45,4.43-.51,5.3-3.99,8.13-5.01,1.94-2.61-.42-1.96,1.38-2.11,2.63-9.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "64.9 46.11 49.18 56.89 53.44 52.04 64.9 46.11"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M56.52,51.85l-7.34,5.04-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08-.27-.31-1.24-1.25-1.6-1.59-.09-.08-.14-.13-.14-.13l-1.84-.98h-.02s0-.01,0-.01l-6.75-3.58,1.37-.62,7.32,3.17,3.43,3.44,10.11-3.09Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "47.04 8.68 39.52 16.85 39.52 16.35 43.28 11.68 47.04 8.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M68.42,29.26l-1.57,13.03-1.95,3.82-8.38,5.75-7.34,5.04-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08-.27-.31-1.24-1.25-1.6-1.59-.09-.08-.14-.13-.14-.13l-1.84-.98h-.02s0-.01,0-.01l-6.75-3.58-5.81-9.51-2.41-3.94-1.66-2.72s.26-1.13.64-2.73c.38-1.61.88-3.7,1.35-5.59.06-.24.12-.48.18-.71.55-2.19,1.02-3.97,1.18-4.19.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7.63-.36,1.3-.73,1.97-1.11,1.03-.59,2.1-1.19,3.15-1.79,4.37-2.48,8.45-4.81,8.58-4.89h0s8.58,5.29,8.58,5.29l5.61,3.46,2.84,4.94,4.26,6.76.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M25.74,30.03c-.04.05-.08.1-.13.14-.03,0-.06,0-.1,0l.22-.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 66.85 42.29 64.9 46.11 49.18 56.89 57.86 42.07 57.49 30.03 61.23 17.43 64.08 22.38 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.34 29.14 62.43 33.16 47.49 22.3 34.5 22.3 47.04 8.68 47.04 8.68 61.23 17.43 64.08 22.38 68.34 29.14"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M39.52,32.11l-.45,8.31-4.79,8.53-9.88-16.17s3.07-13.25,3.37-13.25c.03,0,.29-.13.72-.36l6.02,3.13,5.02,9.81Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 66.85 42.29 62.43 33.16 61.23 17.43 64.08 22.38 68.34 29.14 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "61.23 17.43 51.05 17.43 47.04 8.68 61.23 17.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-130",
    points: "61.01 17.51 53.12 26.39 47.49 22.3 51.05 17.43 54.14 15.34 61.23 17.43"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "55.62 13.97 52.99 16.12 47.04 8.68 55.62 13.97"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M49.18,56.89l-2.14-.45s-2.21-.9-2.36-1.12c-.15-.23-1.8-1.8-1.8-1.8l-8.61-4.57,12.76,1.5,2.14,6.44Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M28.32,26.39l-3.93,6.39s2.92-12.6,3.34-13.23l.03-.02.56,6.86Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.5,22.3l-10.11,10.48s2.92-12.6,3.34-13.23c.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7l1.17,5.83Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.04,50.45l-4.02,3.2c-.09-.08-.14-.13-.14-.13l-8.61-4.57-5.96-22.56,11.2,5.71,7.52,18.34Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M57.6,29.65l-18.08,2.46-10.72-3.9-2.42-3.76c.62-2.5,1.18-4.65,1.35-4.9.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7l17.71.97,6.55,12.21Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "67.51 29.26 65.93 42.29 63.99 46.11 56.95 42.07 49.3 46.2 46.57 22.3 63.91 38.68 67.43 29.14 67.51 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M57.6,31.86l-7.38,14.34-1.04,10.69-2.14-.45s-2.21-.9-2.36-1.12c-.12-.19-1.26-1.28-1.66-1.67-.09-.08-.14-.13-.14-.13l-1.84-.98-1.53-20.44,18.08-.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-130",
    points: "51.05 17.43 34.5 22.3 38.46 13.57 50.83 17.4"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.49,22.3l-9.03-8.74c4.41-2.5,8.51-4.85,8.58-4.89h0s.45,13.63.45,13.63Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.04,8.68l-6.02,4.38-6.52,4.88-6.77,1.62s.02-.02.03-.02c.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7,1.6-.9,3.39-1.91,5.13-2.9,4.37-2.48,8.45-4.81,8.58-4.89"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M35.31,15.35l-.8,2.58-6.77,5.78-3.34,9.07s1.06-4.56,1.99-8.33c.62-2.5,1.18-4.65,1.35-4.9.01-.02.02-.02.03-.02.03,0,.29-.13.72-.36.95-.51,2.74-1.51,4.85-2.7.63-.36,1.3-.73,1.97-1.11"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.28,48.95l-9.88-16.17s.26-1.13.64-2.73l3.64,7.11,5.6,11.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "28.47 39.44 24.4 32.78 27.74 35.33 28.47 39.44"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "41.03 52.53 34.28 48.95 28.47 39.44 26.06 35.5 27.74 35.33 35.31 47.12 41.03 52.53"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M47.49,22.3l-7.97,9.81-8.63,4-3.15-.79-3.34-2.54s.26-1.13.64-2.73c.38-1.61.88-3.7,1.35-5.59.06-.24.12-.48.18-.71l20.93-1.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "68.42 29.26 63.68 25.02 59.18 18.85 55.62 14.85 49.18 12.4 45.82 10.5 47.04 8.68 47.04 8.68 55.62 13.97 61.23 17.43 64.08 22.38 68.34 29.14 68.42 29.26"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "64.9 46.11 49.18 56.89 53.44 52.04 64.9 46.11"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M56.52,51.85l-7.34,5.04-2.14-.45s-2.21-.9-2.36-1.12c-.01-.02-.03-.04-.06-.08-.27-.31-1.24-1.25-1.6-1.59-.09-.08-.14-.13-.14-.13l-1.84-.98h-.02s0-.01,0-.01l-6.75-3.58,1.37-.62,7.32,3.17,3.43,3.44,10.11-3.09Z"
  }))))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M77.14,26.45c4.6,16.05-4.69,32.78-20.73,37.37-16.04,4.6-32.77-4.68-37.37-20.73-1.73-6.06-1.49-12.21.35-17.78-.78,4.14-.63,8.53.61,12.86,4.25,14.84,19.72,23.42,34.56,19.17s23.42-19.73,19.17-34.57c-1.24-4.32-3.43-8.12-6.29-11.22,4.5,3.75,7.96,8.83,9.7,14.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M0,39.93c1.39-4.36,3.37-8.53,5.77-12.49,2.41-3.95,5.31-7.65,8.62-10.99l1.26-1.23,1.3-1.2c.44-.39.9-.77,1.35-1.15.45-.38.92-.74,1.38-1.11,1.86-1.46,3.83-2.78,5.87-4,2.04-1.21,4.17-2.29,6.35-3.23,2.19-.93,4.44-1.72,6.72-2.39,2.29-.63,4.62-1.15,6.96-1.52,2.35-.36,4.72-.57,7.1-.62,2.37-.04,4.75.03,7.1.29,2.35.24,4.68.64,6.97,1.17,4.57,1.07,8.99,2.68,13.13,4.74,4.14,2.08,8.04,4.56,11.53,7.51-2.1-.91-4.19-1.77-6.29-2.57-2.11-.79-4.22-1.52-6.35-2.16-4.25-1.29-8.56-2.25-12.88-2.81-8.64-1.13-17.34-.53-25.59,1.84-8.25,2.35-15.96,6.44-22.68,11.98-3.37,2.76-6.51,5.86-9.43,9.21-1.46,1.67-2.86,3.42-4.23,5.2-1.36,1.79-2.67,3.64-3.96,5.52Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M88.55,17.39v18.96h2.66v1.02h-10.55v-1.02h2.76v-18.96h-2.76v-1.02h10.55v1.02h-2.66ZM92.79,23.48l8.68,12.87h2.44v1.02h-11.04v-1.02h2.57l-6.7-10.03,6.97-7.13c.57-.58.86-1.01.86-1.28,0-.34-.41-.52-1.22-.52h-1.41v-1.02h8.02v1.02h-.8c-.94,0-1.68.12-2.21.37s-1.32.89-2.38,1.95l-3.78,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M109.81,24.56v3.46h.06c.25-1.23.66-2.15,1.24-2.75.57-.6,1.21-.9,1.91-.9s1.23.24,1.66.73c.43.49.64,1.08.64,1.79,0,.61-.16,1.09-.49,1.46-.32.37-.71.56-1.17.56s-.85-.17-1.18-.52c-.33-.34-.49-.73-.49-1.14,0-.52.09-.89.27-1.1.18-.21.27-.34.27-.41,0-.11-.08-.17-.25-.17-.52,0-1.02.51-1.5,1.54-.48,1.02-.71,2.69-.71,4.99v4.31h2.33v.96h-8.24v-.96h1.63v-10.68h-1.63v-.97h2.08c1.11,0,1.92-.03,2.44-.1l.56-.1h.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M122.32,24.37v12.04h1.22v.96h-7v-.96h1.5v-10.68h-1.5v-.97h1.99c1.03,0,1.9-.07,2.6-.2.7-.13,1.1-.2,1.19-.2ZM117.77,19.03c0-.64.22-1.18.67-1.62.44-.44.98-.67,1.6-.67s1.18.22,1.64.67c.45.45.68.99.68,1.61s-.23,1.17-.68,1.62-1,.68-1.64.68-1.16-.23-1.6-.68c-.44-.45-.67-.99-.67-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M134.73,24.37v3.9h-.96c-.58-1.96-1.85-2.94-3.79-2.94-.73,0-1.36.18-1.89.53-.53.35-.8.78-.8,1.28,0,.43.21.76.62.99.41.23,1.46.43,3.16.59,1.69.16,2.89.61,3.59,1.34.7.73,1.05,1.67,1.05,2.81,0,1.43-.44,2.6-1.32,3.52-.88.91-2.07,1.37-3.58,1.37s-2.7-.44-3.66-1.32l-.99.8h-.72v-4.59h.94c.68,2.71,2.17,4.07,4.46,4.07.82,0,1.54-.19,2.14-.58.6-.39.9-.88.9-1.48,0-.42-.16-.76-.48-1.02-.32-.26-1.07-.46-2.27-.6-1.2-.14-2.18-.32-2.95-.55-.77-.23-1.4-.66-1.89-1.28-.49-.62-.74-1.45-.74-2.48,0-1.19.42-2.22,1.25-3.07.84-.86,1.99-1.29,3.46-1.29,1.04,0,2.05.3,3.01.89l.74-.89h.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M142.88,20.85v3.91h3.16v.97h-3.16v8.55c0,1.14.35,1.71,1.05,1.71.64,0,1.12-.57,1.44-1.71h.97c-.19,1.19-.61,2.04-1.25,2.54-.65.51-1.69.76-3.12.76-1.02,0-1.78-.16-2.26-.49-.49-.32-.79-.7-.9-1.14-.12-.44-.17-1-.17-1.68v-8.55h-1.75v-.97h1.75v-3.18l4.24-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M155.65,30.17v-2.82c0-.76-.09-1.3-.28-1.61-.19-.31-.67-.47-1.44-.47-.62,0-1.1.09-1.44.27s-.52.37-.52.56c0,.13.12.31.37.56.25.25.37.56.37.94,0,.54-.2,1.01-.61,1.4-.41.39-.92.59-1.53.59-.56,0-1.05-.19-1.46-.56-.41-.37-.61-.82-.61-1.35,0-.92.55-1.7,1.64-2.34,1.09-.64,2.6-.96,4.53-.96,1.49,0,2.74.19,3.75.56,1.01.38,1.51,1.22,1.51,2.54v6.62c0,1.14.32,1.71.96,1.71.18,0,.42-.1.74-.3l.42.7c-.89,1.03-1.92,1.55-3.08,1.55s-2.24-.63-3.07-1.89c-1.37,1.26-2.89,1.89-4.56,1.89-1.13,0-2.01-.3-2.66-.89-.65-.59-.97-1.33-.97-2.2,0-2.79,2.65-4.29,7.95-4.5ZM155.65,33.04v-2.04c-1.41.05-2.39.27-2.94.67-.55.39-.83,1.05-.83,1.97,0,.71.17,1.27.52,1.68s.79.61,1.33.61c.62,0,1.09-.2,1.42-.61.33-.41.5-1.17.5-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M169.06,16.07v20.34h1.32v.96h-7v-.96h1.41v-19.09h-1.41v-.96c1.32,0,2.61-.05,3.9-.16l1.27-.14h.52Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M93.83,42.11v8.85h.5c2.43,0,3.77-1.24,4.01-3.71h1.16v8.64h-1.02c-.07-1.06-.41-1.98-1.01-2.76-.6-.77-1.65-1.16-3.14-1.16h-.5v9.1h3.01v1.02h-10.8v-1.02h2.66v-18.96h-2.66v-1.02h17.6l.17,6.4h-1.1c-.73-3.59-2.59-5.39-5.57-5.39h-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M110.78,62.49c-2.1,0-3.78-.67-5.03-2.01-1.25-1.34-1.88-2.89-1.88-4.67s.64-3.36,1.91-4.7c1.27-1.34,2.94-2.01,5-2.01s3.76.66,5.04,1.98c1.28,1.32,1.92,2.9,1.92,4.73s-.63,3.39-1.9,4.7c-1.27,1.32-2.96,1.98-5.06,1.98ZM110.78,49.9c-.56,0-1,.13-1.34.4s-.54.67-.61,1.22c-.07.55-.11,1.98-.11,4.28s.03,3.62.1,4.13c.07.51.28.93.63,1.24.35.32.83.48,1.42.48.48,0,.9-.14,1.27-.41.36-.28.58-.78.65-1.5.07-.73.11-1.95.11-3.69,0-2.7-.1-4.41-.31-5.1-.21-.7-.81-1.05-1.81-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M125.08,45.57v3.91h3.16v.97h-3.16v8.55c0,1.14.35,1.71,1.05,1.71.64,0,1.12-.57,1.44-1.71h.97c-.19,1.19-.61,2.04-1.25,2.54-.65.51-1.69.76-3.12.76-1.02,0-1.78-.16-2.26-.49-.49-.32-.79-.7-.9-1.14-.12-.44-.17-1-.17-1.68v-8.55h-1.75v-.97h1.75v-3.18l4.24-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M136.86,62.49c-2.1,0-3.78-.67-5.03-2.01-1.25-1.34-1.88-2.89-1.88-4.67s.64-3.36,1.91-4.7c1.27-1.34,2.94-2.01,5-2.01s3.76.66,5.04,1.98c1.28,1.32,1.92,2.9,1.92,4.73s-.63,3.39-1.9,4.7c-1.27,1.32-2.96,1.98-5.06,1.98ZM136.86,49.9c-.56,0-1,.13-1.34.4s-.54.67-.61,1.22c-.07.55-.11,1.98-.11,4.28s.03,3.62.1,4.13c.07.51.28.93.63,1.24.35.32.83.48,1.42.48.48,0,.9-.14,1.27-.41.36-.28.58-.78.65-1.5.07-.73.11-1.95.11-3.69,0-2.7-.1-4.41-.31-5.1-.21-.7-.81-1.05-1.81-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M151.32,49.1v2.66h.06c1.11-1.77,2.66-2.66,4.65-2.66.89,0,1.66.19,2.33.56.67.38,1.09.76,1.28,1.15.18.39.27.99.27,1.78v8.54h1.78v.96h-7.88v-.96h1.82v-8.78c0-.79-.11-1.31-.32-1.55-.21-.24-.51-.36-.9-.36-.52,0-1.17.33-1.94.99s-1.16,1.81-1.16,3.46v6.24h1.83v.96h-7.94v-.96h1.83v-10.68h-1.8v-.97h1.15c1.04,0,2.06-.07,3.08-.2l1.4-.2h.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M168.71,49.1v12.04h1.22v.96h-7v-.96h1.5v-10.68h-1.5v-.97h1.99c1.03,0,1.9-.07,2.6-.2.7-.13,1.1-.2,1.19-.2ZM164.15,43.76c0-.64.22-1.18.67-1.62.44-.44.98-.67,1.6-.67s1.18.22,1.64.67c.45.45.68.99.68,1.61s-.23,1.17-.68,1.62-1,.68-1.64.68-1.16-.23-1.6-.68c-.44-.45-.67-.99-.67-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M177.4,40.8v14.57l3.34-3.21s.19-.22.51-.56c.32-.34.48-.56.48-.67,0-.32-.37-.47-1.11-.47h-.88v-.97h6.64v.97h-.47c-.77,0-1.39.07-1.86.22-.47.15-1.02.53-1.64,1.16l-1.53,1.53,5.64,7.77h1.25v.96h-8.02v-.96h1.68l-3.95-5.6h-.06v5.6h1.44v.96h-7.47v-.96h1.8v-19.09h-1.8v-.96h1.44l3.76-.3h.83Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvg65);
export default __webpack_public_path__ + "static/media/LogoSvg65.ae8ec1f7129b7422f70eb838f5cc87d9.svg";
export { ForwardRef as ReactComponent };